import React from 'react';
import i18n from "../i18n";
import property from '../config/config';
  export default function main() {
    return (
      <div>
          {/* <a href="/" name="footer"></a> */}
          <footer className="pt-4 my-md-5 pt-md-5 border-top">
            <div className="row">
            <div className="col-12 col-md">
                <img className="mb-2" src="https://getbootstrap.com/docs/4.0/assets/brand/bootstrap-solid.svg" alt="" width="24" height="24"/>
                <small className="d-block mb-3 text-muted">&copy; 2017-2018</small>

                <h3 className="c-font-uppercase c-font-bold "> </h3>
                {property.company.FULL_NAME}
                <br/> {property.company.ADDRESS}
                <br/> {i18n.t('CONTACT_PHONE')} {property.company.PHONE}
                <br/> <span>{i18n.t('CONTACT_EMAIL')} </span>
                <a href={"mailto:" + property.company.EMAIL} > 
                    <span className="c-theme-color">{property.company.EMAIL}</span>
                </a>

                
                { property.company.social.hasOwnProperty('youtube_url') ? <a href={property.company.social.youtube_url} target="_blank" rel="noopener noreferrer"><i className="fab fa-2x fa-youtube" style={{marginLeft:"15px",color:"#FF0000"}} ></i></a> : ""}
                { property.company.social.hasOwnProperty('instagram_url') ? <a href={property.company.social.instagram_url} target="_blank" rel="noopener noreferrer"><i className="fab fa-2x fa-instagram" style={{marginLeft:"15px",color:"#9b6954"}} ></i></a> : ""}
                { property.company.social.hasOwnProperty('twitter_url') ? <a href={property.company.social.twitter_url} target="_blank" rel="noopener noreferrer"><i className="fab fa-2x fa-twitter" style={{marginLeft:"15px",color:"#1DA1F2"}} ></i></a> : ""}
                { property.company.social.hasOwnProperty('linkedin_url') ? <a href={property.company.social.linkedin_url} target="_blank" rel="noopener noreferrer"><i className="fab fa-2x fa-linkedin" style={{marginLeft:"15px",color:"#1DA1F2"}} ></i></a> : ""}
                { property.company.social.hasOwnProperty('line_url') ? <a href={property.company.social.line_url} target="_blank" rel="noopener noreferrer"><i className="fab fa-2x fa-line" style={{marginLeft:"15px",color:"#00c300"}} ></i></a> : ""}
            </div>
            <div className="col-6 col-md">
                <h5>{i18n.t('CONTACT')}</h5>
                <ul className="list-unstyled text-small">
                {/* <li><a className="text-muted" href="/">{ property.company.social.hasOwnProperty('facebook_url') ? <a href={property.company.social.facebook_url} target="_blank" rel="noopener noreferrer"><i className="fab fa-2x fa-facebook-square" style={{marginLeft:"15px",color:"#3b5998"}} ></i></a> : ""}</a></li> */}
                <li><a className="text-muted" href="/">Random feature</a></li>
                <li><a className="text-muted" href="/">Team feature</a></li>
                <li><a className="text-muted" href="/">Stuff for developers</a></li>
                <li><a className="text-muted" href="/">Another one</a></li>
                <li><a className="text-muted" href="/">Last time</a></li>
                </ul>
            </div>
            <div className="col-6 col-md">
                <h5>Features</h5>
                <ul className="list-unstyled text-small">
                <li><a className="text-muted" href="/">Cool stuff</a></li>
                <li><a className="text-muted" href="/">Random feature</a></li>
                <li><a className="text-muted" href="/">Team feature</a></li>
                <li><a className="text-muted" href="/">Stuff for developers</a></li>
                <li><a className="text-muted" href="/">Another one</a></li>
                <li><a className="text-muted" href="/">Last time</a></li>
                </ul>
            </div>
            <div className="col-6 col-md">
                <h5>Resources</h5>
                <ul className="list-unstyled text-small">
                <li><a className="text-muted" href="/">Resource</a></li>
                <li><a className="text-muted" href="/">Resource name</a></li>
                <li><a className="text-muted" href="/">Another resource</a></li>
                <li><a className="text-muted" href="/">Final resource</a></li>
                </ul>
            </div>
            <div className="col-6 col-md">
                <h5>About</h5>
                <ul className="list-unstyled text-small">
                <li><a className="text-muted" href="/">Team</a></li>
                <li><a className="text-muted" href="/">Locations</a></li>
                <li><a className="text-muted" href="/">Privacy</a></li>
                <li><a className="text-muted" href="/">Terms</a></li>
                </ul>
            </div>
            </div>
        </footer>



        <footer className="c-layout-footer c-layout-footer-6 c-bg-grey-1">
            <div className="container">
                <div className="c-prefooter " style={{backgroundColor: "#FFF"}} >
                    <div className="c-foot">
                        <div className="row">
                            <div className="col-md-6">
                                <div className="c-content-title-1 c-title-md">
                                    
                                    <div className="c-line-left hide"></div>
                                </div>
                                <p className="c-text c-font-18 font-BoonJot-Italic ">
                                    
                                </p>
                            </div>
                            <div className="col-md-6">
                                <div className="c-right">
                                    <div className="socicon">
                                        {/* { property.exists('company.SOCIAL.FACEBOOK_LINK') ? }
                                        {/* { property.company.social.hasOwnProperty('twitter_url') ? "111" : ""} */}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="c-postfooter c-bg-dark-2">
                <div className="container">
                    <div className="row">
                        <div className="col-md-6 col-sm-12 c-col">
                            <p className="c-copyright c-font-grey">
                                <span>{property.company.copy_right}</span>
                                <span className="c-font-grey-3"> All Rights Reserved.</span>
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </footer>
      </div>
    );
  }

  //I18n.t("some_translation.key", :default => "fallback text")